import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Home from "./components/home/Home";
import InfosEnfant from "./components/infos_enfant/InfosEnfant";
import InfosReferences from "./components/infos_references/InfosReferences";
import InfosGenerales from "./components/infos_generales/InfosGenerales";
import ObservationsMalade from "./components/observations_malade/ObservationsMalade";
import CartographieSites   from "./components/cartographie_sites/CartographieSites";
import ResultatsBilan      from "./components/resultats_bilan/ResultatsBilan";
import ConclusionCartographieSite from "./components/conclusion_cartographie_site/ConclusionCartographieSite";
import DecisionTherapeutique from "./components/decision_therapeutique/DecisionTherapeutique";
import EvaluationPathologie from "./components/evaluation_pathologie/EvaluationPathologie";
import TraitementDeuxiemeLigne from "./components/traitement_deuxieme_ligne/TraitementDeuxiemeLigne";
import PremiereHospitalisation from "./components/premiere_hospitalisation/PremiereHospitalisation";
import NouvelleHospitalisation from "./components/nouvelle_hospitalisation/NouvelleHospitalisation";
import DernieresNouvelles from "./components/dernieres_nouvelles/DernieresNouvelles";
import CourbeCroissance from "./components/courbe_croissance/CourbeCroissance";
import ProtectedRoute from "./components/shared/ProtectedRoute";
import GlobalLoader from "./components/shared/GlobalLoader";
import { Toaster } from 'react-hot-toast';
import PagesAnnexes from "./components/pages_annexes/PagesAnnexes";
import ExamensMedicaux from "./components/examens_medicaux/ExamenMedical";
import Galerie from "./components/galerie/Galerie";
import Login from "./components/auth/Login";
import useSpeechRecognition from "./hooks/useSpeechRecognition";
import "./App.css";
/* import 'bootstrap/dist/css/bootstrap.min.css'; */


const AppContent = () => {
  const { listening, startListening, stopListening } = useSpeechRecognition();
  const [authUser, setAuthUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("nexamed_portal_user") || "null"); } catch (_) { return null; }
  });
  if (!authUser) return <Login onLogin={setAuthUser} />;
  const logout = () => {
    try { localStorage.removeItem("nexamed_portal_user"); } catch (_) {}
    setAuthUser(null);
  };

  return (
    <>
      <button onClick={logout} title={`Déconnexion (${authUser.name || authUser.email})`}
        style={{ position: "fixed", top: 12, right: 12, zIndex: 9997, width: 40, height: 40,
                 borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff",
                 cursor: "pointer", boxShadow: "0 4px 12px rgba(15,23,42,.12)", fontSize: 18 }}>⏻</button>
      <GlobalLoader />
      <Toaster position="top-right" toastOptions={{
        success: { duration: 3000 },
        error:   { duration: 4000 },
        style: {
          fontSize: '20px',
          padding: '30px 30px',
          minWidth: '280px',
        },
      }} />

    <button
      className={`btn-mic ${listening ? "btn-mic--active" : ""}`}
      onClick={listening ? stopListening : startListening}
      title={listening ? "Arrêter la dictée" : "Démarrer la dictée"}
    >
        {listening && <span className="btn-mic__pulse" />}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8"  y1="23" x2="16" y2="23"/>
        </svg>
      </button>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dossier/:id" element={<ProtectedRoute><InfosEnfant /></ProtectedRoute>} />
        <Route path="/dossier/:id/references" element={<ProtectedRoute><InfosReferences /></ProtectedRoute>} />
        <Route path="/dossier/:id/generales" element={<ProtectedRoute><InfosGenerales /></ProtectedRoute>} />
        <Route path="/dossier/:id/observations" element={<ProtectedRoute><ObservationsMalade /></ProtectedRoute>} />
        <Route path="/dossier/:id/cartographie" element={<ProtectedRoute><CartographieSites /></ProtectedRoute>} />
        <Route path="/dossier/:id/resultats-bilan" element={<ProtectedRoute><ResultatsBilan /></ProtectedRoute>} />
        <Route path="/dossier/:id/conclusion-cartographie" element={<ProtectedRoute><ConclusionCartographieSite /></ProtectedRoute>} />
        <Route path="/dossier/:id/decision-therapeutique" element={<ProtectedRoute><DecisionTherapeutique /></ProtectedRoute>} />
        <Route path="/dossier/:id/evaluation-pathologie" element={<ProtectedRoute><EvaluationPathologie /></ProtectedRoute>} />
        <Route path="/dossier/:id/traitement-deuxieme-ligne" element={<ProtectedRoute><TraitementDeuxiemeLigne /></ProtectedRoute>} />
        <Route path="/dossier/:id/premiere-hospitalisation" element={<ProtectedRoute><PremiereHospitalisation /></ProtectedRoute>} />
        <Route path="/dossier/:id/nouvelle-hospitalisation" element={<ProtectedRoute><NouvelleHospitalisation /></ProtectedRoute>} />
        <Route path="/dossier/:id/dernieres-nouvelles" element={<ProtectedRoute><DernieresNouvelles /></ProtectedRoute>} />
        <Route path="/dossier/:id/courbe-croissance" element={<ProtectedRoute><CourbeCroissance /></ProtectedRoute>} />
        <Route path="/dossier/:id/pages-annexes" element={<ProtectedRoute><PagesAnnexes /></ProtectedRoute>} />
        <Route path="/dossier/:id/examens-medicaux" element={<ProtectedRoute><ExamensMedicaux /></ProtectedRoute>} />
        <Route path="/dossier/:id/galerie" element={<ProtectedRoute><Galerie /></ProtectedRoute>} />
      </Routes>
    </>
  );
};

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
}

export default App;